import { Injectable } from '@angular/core';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { RequestService } from '@core/services/request/request.service';
import { Observable } from 'rxjs';
import {
  AccumulatedConsumptionApi,
  ConsumptionFilterApi,
  DailyAccumulatedConsumptionApi,
  MonthlyAccumulatedConsumptionApi,
  YearlyAccumulatedConsumptionApi,
} from '../../model/consumption/consumption-api.model';
import { HttpParamsService } from '@core/services/http-params/http-params.service';
import { LoadingIds } from '@shared/constants/loading';

@Injectable({
  providedIn: 'root',
})
export class ApiAccumulatedService {
  constructor(
    private _requestService: RequestService,
    private _httpParamsService: HttpParamsService
  ) {}

  public fetchDaily(filter: ConsumptionFilterApi): Observable<RequestResponse<AccumulatedConsumptionApi<DailyAccumulatedConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.Consumo.AcumuladoDiario({}), {
      params: this._httpParamsService.toParams(filter),
      hideErrorAlert: true,
      loading: LoadingIds.FETCH_ACCUMULATED_CONSUMPTION,
    });
  }

  public fetchMonthly(
    filter: ConsumptionFilterApi
  ): Observable<RequestResponse<AccumulatedConsumptionApi<MonthlyAccumulatedConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.Consumo.AcumuladoMensual({}), {
      params: this._httpParamsService.toParams(filter),
      hideErrorAlert: true,
      loading: LoadingIds.FETCH_ACCUMULATED_CONSUMPTION,
    });
  }

  public fetchYearly(
    filter: ConsumptionFilterApi
  ): Observable<RequestResponse<AccumulatedConsumptionApi<YearlyAccumulatedConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.Consumo.AcumuladoAnual({}), {
      params: this._httpParamsService.toParams(filter),
      hideErrorAlert: true,
      loading: LoadingIds.FETCH_ACCUMULATED_CONSUMPTION,
    });
  }

  public downloadExcelDaily(filter: ConsumptionFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.Consumo.AcumuladoExcelDiario({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }

  public downloadExcelMonthly(filter: ConsumptionFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.Consumo.AcumuladoExcelMensual({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }

  public downloadExcelYearly(filter: ConsumptionFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.Consumo.AcumuladoExcelAnual({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }
}
